import { API } from "../backend";

// Safe stringify for objects
const safeStringify = (value) => {
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
  return String(value);
};

// Queue for batching - send every 3 seconds
let logQueue = [];
const BATCH_INTERVAL = 3000;
const MAX_BATCH_SIZE = 20;

// Send queued logs to backend
const flushLogQueue = async () => {
  if (logQueue.length === 0) return;
  const batch = [...logQueue];
  logQueue = [];
  try {
    await fetch(`${API}/client/log/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(batch)
    });
  } catch (err) {
    console.error('Failed to send batch logs', err);
    // Requeue the logs if failed
    logQueue.unshift(...batch);
  }
};

// Periodically flush logs
setInterval(flushLogQueue, BATCH_INTERVAL);

// Console logger
const logToConsole = (level, logObject) => {
  const timestamp = new Date().toISOString();
  try {
    console[level](`[${timestamp}] [${level.toUpperCase()}]`, logObject);
  } catch (err) {
    console.error('Logging to console failed', err);
  }
};

// Add log to batch queue and console
const queueLog = (level, logObject) => {
  logQueue.push({ level, ...logObject, timestamp: new Date().toISOString() });
  if (logQueue.length >= MAX_BATCH_SIZE) {
    flushLogQueue();
  }
};

// Structured log functions
const clientLogger = {
  logInfo: (flow, text, id = null, data = null) => {
    queueLog('info', { flow: flow, text: text, data: safeStringify(data), id: id });
  },
  logWarn: (flow, text, id = null, data = null) => {
    queueLog('warn', { flow: flow, text: text, data: safeStringify(data), id: id });
  },
  logError: (flow, text, id = null, data = null) => {
    queueLog('error', { flow: flow, text: text, data: safeStringify(data), id: id });
  },
  logCritical: (flow, text, id = null, data = null) => {
    queueLog('error', { flow: flow, text: `[CRITICAL] ${text}`, data: safeStringify(data), id: id });
  }
};

export default clientLogger;